import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import PropTypes from "prop-types";
import Modal from "@mui/material/Modal";
import pointBrand from "../../../assets/images/icons/catering-icons/ic-my-points.svg";
import { useAuth } from "context";
import Box from "@mui/material/Box";
import SimpleBackdrop from "components/MDLoader_Backdrop";

const CustomModal = ({
  title,
  subtittle,
  icon,
  handleClose,
  open,
  color,
  userEmail,
  loader,
  onConfirm,
  description,
  isIcon,
}) => {
  const { darkMode } = useAuth();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "90%", xl: "400px" },
    maxWidth: "400px",
    bgcolor: !darkMode ? "background.paper" : "#202940",
    boxShadow: 10,
    p: "24px",
    borderRadius: 2,
  };
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={style}>
          <card>
            <MDBox>
              {isIcon && (
                <MDBox
                  variant="gradient"
                  bgColor={color}
                  color={color === "light" ? "dark" : "white"}
                  coloredShadow={color}
                  borderRadius="xl"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="4rem"
                  height="4rem"
                  mt={-8}
                  mb={4}
                  position="relative"
                  left={"45%"}
                >
                  <MDBox component="img" src={pointBrand} alt="pointBrand" width="2rem" />
                </MDBox>
              )}
              <MDBox lineHeight={1}>
                <MDTypography
                  textAlign="left"
                  sx={{ fontSize: "18px", color: "#181D27" }}
                  fontWeight="medium"
                >
                  {title}
                  {subtittle}
                </MDTypography>
              </MDBox>
              <MDTypography variant="button" fontWeight="bold" color="secondary">
                {userEmail}
              </MDTypography>
              <br />
              <MDTypography variant="button" fontWeight="light" color="text">
                {description}
              </MDTypography>

              <MDBox
                textAlign="right"
                mt={6}
                sx={{ display: "flex", gap: 2, justifyContent: "space-between" }}
              >
                <MDButton
                  variant="outlined"
                  color={"secondary"}
                  fullWidth
                  size="medium"
                  onClick={handleClose}
                  sx={{ textTransform: "none" }}
                >
                  {"Cancel"}
                </MDButton>
                <MDButton
                  fullWidth
                  variant="contained"
                  color={"error"}
                  size="medium"
                  disabled={loader}
                  onClick={() => onConfirm()}
                  sx={{ textTransform: "none" }}
                >
                  {"Confirm"}
                </MDButton>
              </MDBox>
            </MDBox>
          </card>
        </Box>
      </Modal>
      {loader && <SimpleBackdrop />}
    </>
  );
};

CustomModal.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  subtittle: PropTypes.string,
  userEmail: PropTypes.string,
  onConfirm: PropTypes.func,
  loader: PropTypes.bool,
  description: PropTypes.string,
  isIcon: PropTypes.bool,
};

export default CustomModal;
